import EllipsisTooltipText from "./EllipsisTooltipText";
import { displayFeedCardTitle, sanitizePublicCardTitle } from "../../Utils/media/feedCardTitle";

const ProductName = (props: any) => {
  const { type, post, title, creatorUsername } = props;
  const {
    product_name,
    content_title,
    shop_title,
    table_name,
    platform,
    product_image,
  } = post || {};

  // Vertical rhythm comes from `.creator-post-stack` / `.link-url` gap — don't add % margins.
  const style: React.CSSProperties = {
    ...(props?.designTokens && {
      fontFamily: props?.designTokens?.secondaryFontFamily,
    }),
  };

  const sanitizeOpts = {
    creatorUsername:
      creatorUsername ||
      post?.username ||
      post?.instagram_username ||
      post?.handle ||
      null,
  };

  const renderProductName = (text: string) => {
    const cleaned = sanitizePublicCardTitle(text, post, sanitizeOpts);
    if (!cleaned) return null;
    return (
      <EllipsisTooltipText text={cleaned} style={style} fillWidth />
    );
  };

  return (
    <>
      {platform === "youtube" &&
      product_image &&
      product_image !== "" ? null : platform === "MISC-content" ? (
        sanitizePublicCardTitle(content_title || shop_title, post, sanitizeOpts)
          ? renderProductName(content_title || shop_title)
          : null
      ) : (
        <>
          {type === "content" || type === "query-content"
            ? content_title || product_name
              ? renderProductName(content_title || product_name)
              : null
            : type === "links" || type === "query-links"
            ? shop_title || product_name
              ? renderProductName(shop_title || product_name)
              : null
            : type === "MAIL"
            ? renderProductName(content_title || product_name)
            : type === "product-bank"
            ? shop_title || table_name
              ? renderProductName(shop_title || table_name)
              : null
            : displayFeedCardTitle(post, sanitizeOpts)
            ? renderProductName(displayFeedCardTitle(post, sanitizeOpts))
            : null}
        </>
      )}
    </>
  );
  // return (
  //   <>      
  //   {platform === "youtube" && product_image ? null : platform === "MISC-content" ? (
  //       content_title || shop_title ? (
  //         renderText(content_title || shop_title)
  //       ) : null
  //     ) : (
  //       <>
  //         {type === "content" || type === "query-content" ? (
  //           content_title ? (
  //             renderText(content_title)
  //           ) : null
  //         ) : type === "MAIL" ? (
  //           content_title ? (
  //             renderText(content_title)
  //           ) : (
  //             renderText(product_name)
  //           )
  //         ) : type === "product-bank" ? (
  //           shop_title ? (
  //             renderText(shop_title)
  //           ) : (
  //             renderText(table_name)
  //           )
  //         ) : post?.shop_title ? (
  //           renderText(shop_title)
  //         ) : post?.content_title ? (
  //           renderText(content_title)
  //         ) : post?.product_name ? (
  //           renderText(product_name)
  //         ) : null}
  //       </>
  //     )}
  //   </>
  // );
};

export default ProductName;
